import type { MetaObject } from 'nuxt/schema';
import { getISODateString } from '@devhacker/shared/utils/date';
import type { Seo } from '../../seo/model/schemas';

type ArticleAnalyticsData = {
  author?: {
    name?: string;
  };
  categories: Array<{
    title: string;
    url: string;
  }>;
  date?: number;
  isAdvertising?: boolean;
  isPromo?: boolean;
  meta?: {
    lh_first_published_time?: number | null;
  };
  tags: Array<{
    title: string;
  }>;
};

export function useArticleAnalyticsHead(article: ArticleAnalyticsData | null, seo: Seo | null) {
  if (import.meta.client || !article || !seo) return;

  useHead({
    meta: createArticleAnalyticsMeta(article, seo.title),
  });
}

function createArticleAnalyticsMeta(
  article: ArticleAnalyticsData,
  title: string,
): NonNullable<MetaObject['meta']> {
  const firstTopic = article.categories.find((item): boolean => item.url.includes('topics/'));
  const firstStream = article.categories.find((item): boolean => item.url.includes('stream/'));
  const technicalTags = ['noad', 'nozen', 'hide', 'noturbo', 'noadsense'];
  const firstTag = article.tags.find((item): boolean => !technicalTags.includes(item.title));
  const partner = article.isAdvertising || article.isPromo ? 'Партнёрский материал' : 'null';
  const firstPublishedDate = article.meta?.lh_first_published_time || null;

  return [
    { key: 'lh_page_title', name: 'lh_page_title', content: title },
    { key: 'lh_author', name: 'lh_author', content: article.author?.name ?? 'null' },
    { key: 'lh_category', name: 'lh_category', content: firstTopic?.title ?? 'null' },
    { key: 'lh_stream', name: 'lh_stream', content: firstStream?.title ?? 'null' },
    { key: 'lh_tag', name: 'lh_tag', content: firstTag?.title ?? 'null' },
    { key: 'lh_partner', name: 'lh_partner', content: partner },
    {
      key: 'lh_published_time',
      name: 'lh_published_time',
      content: article.date ? getISODateString(new Date(1000 * article.date)) : 'null',
    },
    {
      key: 'lh_first_published_time',
      name: 'lh_first_published_time',
      content:
        firstPublishedDate !== null
          ? getISODateString(new Date(firstPublishedDate * 1000))
          : 'null',
    },
  ];
}
